import { render, staticRenderFns } from "./select-fleet.vue?vue&type=template&id=22e96c48&scoped=true"
import script from "./select-fleet.vue?vue&type=script&lang=js"
export * from "./select-fleet.vue?vue&type=script&lang=js"
import style0 from "./select-fleet.vue?vue&type=style&index=0&id=22e96c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e96c48",
  null
  
)

export default component.exports